/** Collapsed-by-default list of grouped ticket changes. */

import { useMemo, useState } from 'react';
import { formatInstant } from '@ampersandbrands/ui';
import type { SdTicketEvent } from '@/lib/serviceDeskTypes';
import { SD_BTN_GHOST, SD_MUTED } from './sdStyles';
import { groupEvents } from './timelineGroups';

export function TimelineHistory({ events }: { events: SdTicketEvent[] }) {
  const [open, setOpen] = useState(false);
  const groups = useMemo(() => groupEvents(events), [events]);
  if (groups.length === 0) return null;
  const count = groups.reduce((n, g) => n + g.lines.length, 0);

  return (
    <div>
      <button type="button" className={SD_BTN_GHOST} aria-expanded={open} onClick={() => setOpen((v) => !v)}>
        {open ? 'Hide history' : `Show history (${count} ${count === 1 ? 'change' : 'changes'})`}
      </button>
      {open && (
        <ol className="mt-2 flex flex-col gap-3 border-l border-amp-line pl-3 dark:border-amp-dark-line">
          {groups.map((g) => (
            <li key={g.key} className="text-[12px]">
              <p className={`font-semibold ${SD_MUTED}`}>
                {formatInstant(g.at)} - {g.actor}
              </p>
              <ul className={`mt-0.5 list-disc pl-5 ${SD_MUTED}`}>
                {g.lines.map((l, i) => (
                  <li key={i}>{l}</li>
                ))}
              </ul>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
